import React from "react";
import { Link } from "react-router-dom";
import { Building2, Check } from "lucide-react";

// Thank-you page: Spanish only per requirements.
export default function ThankYou() {
  return (
    <main
      className="min-h-[calc(100vh-0px)] bg-white"
      data-testid="page-thank-you"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-8 py-24 md:py-32 text-center">
        <div className="mx-auto inline-flex h-16 w-16 items-center justify-center bg-[#0C111D] text-white">
          <Check size={28} strokeWidth={2} />
        </div>
        <p
          className="mt-8 text-xs uppercase tracking-widest font-bold text-[#1E3A8A]"
          data-testid="thankyou-eyebrow"
        >
          Suscripción confirmada
        </p>
        <h1
          className="mt-4 font-serif font-medium text-4xl md:text-5xl text-[#101828] tracking-tight leading-[1.05]"
          data-testid="thankyou-title"
        >
          ¡Gracias por sumarte a Vivendario!
        </h1>
        <p
          className="mt-6 text-lg text-[#475467] leading-relaxed"
          data-testid="thankyou-body"
        >
          Recibimos tus datos correctamente. En los próximos días te enviaremos
          por correo electrónico las oportunidades de crowdlending inmobiliario
          publicadas en la plataforma, junto con novedades del mercado
          residencial argentino.
        </p>
        <p className="mt-4 text-sm text-[#475467] leading-relaxed">
          Mientras tanto, podés volver al inicio para explorar los tipos de
          proyectos y conocer cómo funciona la plataforma.
        </p>

        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            data-testid="thankyou-back-home-btn"
            className="inline-flex items-center gap-2 bg-[#1E3A8A] text-white px-6 h-12 text-sm font-semibold tracking-wide hover:bg-[#1E40AF] no-underline"
          >
            <Building2 size={16} />
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
